export const PATH_LOGIN = "/login";
export const PATH_DIARY = "/diary";
export const PATH_OVERVIEW = "/overview";
export const PATH_MANAGERS = "/managers";
export const PATH_DASHBOARD = "/dashboard";



// WEBPACK FOOTER //
// ./src/routes.js